module.exports = __webpack_public_path__ + "static/media/tree-alt.0f44856e.svg";